export default {
  appendStep: 'Dołącz krok',
  insertStep: 'Wstaw krok przed',
  stepMoveUp: 'Podnieść',
  stepMoveDown: 'Opuść',
};
